const PageSection = ({ children }) => (
  <div className="section">
    {children}

    <style jsx>{`
      .section {
        margin-top: 30px;
      }
      .section:not(:first-of-type) {
        margin-top: 80px;
      }
    `}</style>
  </div>
);

export default PageSection;
